import { ViewLayout } from '@lithos';
import IngestServerGroupsTableView from './IngestServerGroupsTableView';
import TransformServerGroupsTableView from './TransformServerGroupsTableView';
import { Navigate, Route, Routes, useNavigate } from 'react-router';
import { useUserSettings } from '../../context/UserSettingsContext';

const ServerGroupsContainer = () => {
  const navigate = useNavigate();
  const pathSegments = location.pathname.split('/');
  const currentPath = pathSegments[pathSegments.length - 1];
  const selectedTab = currentPath === 'transform-server-groups' ? 'Transform Server Groups' : 'Ingest Server Groups';
  const { workspace } = useUserSettings();

  const serverGroupsRoutes = [
    {
      label: 'Transform Server Groups',
      route: 'transform-server-groups',
    },
    {
      label: 'Ingest Server Groups',
      route: 'ingest-server-groups',
    },
  ];

  return (
    <ViewLayout
      header={{
        breadcrumbs: {
          root: { label: workspace ?? '', url: `/app/repo/${workspace}` },
          items: [{ label: 'Server Groups', url: '/server-groups' }],
        },
        tabs: {
          items: serverGroupsRoutes,
          selectedTab: selectedTab,
          setSelectedTab: (tab: string) => {
            const route = serverGroupsRoutes.find((route) => route.label === tab)?.route;
            if (route) {
              navigate(route);
            }
          },
        },
        title: undefined,
      }}
      content={
        <Routes>
          <Route index element={<Navigate to={'transform-server-groups'} />} />
          <Route path={'transform-server-groups'} element={<TransformServerGroupsTableView />} />
          <Route path={'ingest-server-groups'} element={<IngestServerGroupsTableView />} />
        </Routes>
      }
    />
  );
};

export default ServerGroupsContainer;
